"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCountDownTimer = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _utils = require("./utils");
var useCountDownTimer = exports.useCountDownTimer = function useCountDownTimer(_ref) {
  var serverTimeToStart = _ref.serverTimeToStart,
    serverTimeToEnd = _ref.serverTimeToEnd,
    streamStatus = _ref.streamStatus,
    stoppedReason = _ref.stoppedReason;
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    duration = _useState4[0],
    setDuration = _useState4[1];
  var _useState5 = (0, _react.useState)('dark'),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    color = _useState6[0],
    setColor = _useState6[1];
  (0, _react.useEffect)(function () {
    setText((0, _utils.getCountDownText)(serverTimeToStart, streamStatus));
  }, [serverTimeToStart, streamStatus]);
  (0, _react.useEffect)(function () {
    setDuration((0, _utils.getFormattedCountDownDuration)(serverTimeToStart, serverTimeToEnd, streamStatus));
  }, [serverTimeToStart, serverTimeToEnd, streamStatus]);
  (0, _react.useEffect)(function () {
    setColor((0, _utils.getCountDownColor)(serverTimeToStart, serverTimeToEnd, streamStatus, stoppedReason));
  }, [serverTimeToStart, serverTimeToEnd, streamStatus, stoppedReason]);
  return {
    text: text,
    duration: duration,
    color: color
  };
};